import { Theme, useTheme } from '@mui/material/styles';
import { ENVIRONMENT } from '@/constants/environment';
import { getEnvColor } from '@/contexts/theme/utils';
import envVariables from '@/envVariables';
import { NavBarBadge } from '../common/NavBarBadge';

export const EnvironmentInfo = () => {
  const theme = useTheme<Theme>();
  const env = envVariables.env;
  const { DEV, STAGING, SANDBOX } = ENVIRONMENT;

  if ([DEV, STAGING, SANDBOX].includes(env)) {
    const envColor = getEnvColor(theme, env);
    return (
      <NavBarBadge
        label={env}
        sxProps={{
          color: theme.palette.getContrastText(envColor),
          bgcolor: envColor,
        }}
      />
    );
  }
  return null;
};
